import { Button } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { FormButtons } from '@tabeeb/modules/forms/services/enums'
import { getFormButtonState } from '@tabeeb/modules/forms/selectors'
import { requestRework } from '@tabeeb/modules/contentReviews/actions'

const SendReviewFeedbackButton = () => {
  const dispatch = useDispatch()

  const { isDisabled } = useSelector((state) => getFormButtonState(state, { button: FormButtons.SendReviewFeedback }))

  return (
    <Button
      size='small'
      color='primary'
      variant='contained'
      disabled={isDisabled}
      fullWidth
      onClick={() => dispatch(requestRework())}
    >
      Send feedback
    </Button>
  )
}

export default SendReviewFeedbackButton

